import PropTypes from "prop-types";
import ProductCard from "../../components/ProductCard/ProductCard";

const OtherRentals = ({
  devices,
  addToCart,
  removeFromCart,
  cartItems,
  selectedQuantities,
}) => {
  // Jos laitelista on tyhjä, näytetään viesti
  if (!devices || devices.length === 0) {
    return (
      <div className="text-center py-10">
        <h2 className="text-5xl sm:text-6xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-tight text-center font-customFont2 text-darkest dark:text-primary dark:text-shadow-xxl">Muut vuokrattavat</h2>
        <p className="font-customFont1 dark:text-shadow-lg text-center text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light pb-10">
          Ladataan muita vuokrattavia..
        </p>
      </div>
    );
  }

  return (
    <div className="dark:bg-violet bg-primary dark:bg-opacity-75 bg-opacity-75 pb-10 py-5 p-5 max-w-7xl mx-auto mt-10 rounded-3xl">
      <div className="flex flex-row items-center flex-wrap">
        <h2 className="text-5xl sm:text-6xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-tight text-left font-customFont2 text-darkest dark:text-primary dark:text-shadow-xxl">
          Muut vuokrattavat
        </h2>
      </div>

      <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light pb-10">
        Tähän osioon on koottu muita tuotteita tai palveluita, joita myymme tai tarjoamme vuokralle.
      </p>

      <div className="grid grid-cols-1 xxxsm:grid-cols-1 xxsm:grid-cols-1 s24:grid-cols-1 xsm:grid-cols-2 sm:grid-cols-3 md:grid-cols-3 mdd:grid-cols-4 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-4">
        {devices.map((item) => {
          const isCamera = item.category === "Kamerat";

          return (
            <ProductCard
              key={item.id}
              item={item}
              isBooked={item.isBooked}
              isDisabled={item.isBooked || parseInt(item.available, 10) === 0}
              addToCart={!isCamera ? addToCart : null}
              removeFromCart={removeFromCart}
              cartItems={cartItems}
              selectedQuantities={selectedQuantities}
            >
              {/* Lisätiedot-nappi HIRVI 350 -kärrylle */}
              {item.name?.toLowerCase().includes("hirvi") && (
                <div className="mt-2">
                  <a
                    href="/detailedservices#kuljetuspalvelu"
                    className="text-primary underline hover:text-linkcolhover transition"
                  >
                    Lisätiedot kuljetuspalvelusta
                  </a>
                </div>
              )}
            </ProductCard>
          );
        })}
      </div>
    </div>
  );
};

OtherRentals.propTypes = {
  devices: PropTypes.array.isRequired,
  addToCart: PropTypes.func.isRequired,
  removeFromCart: PropTypes.func.isRequired,
  cartItems: PropTypes.array.isRequired,
  selectedQuantities: PropTypes.object.isRequired,
};

export default OtherRentals;
